export const APPLICATION_JSON = 'application/json';
export const CONTENT_TYPE = 'Content-Type';
export const MULTIPART_FORM_DATA = 'multipart/form-data';
